<script setup lang="ts">
import { useTemplateRef } from 'vue';
import BaseModal from '../../headless/BaseModal.vue';

withDefaults(defineProps<{
    buttonUrl?: string;
}>(), {
    buttonUrl: '',
});

const open = defineModel<boolean>('open');

const loginButtonRef = useTemplateRef('loginButtonRef');
</script>

<template>
    <BaseModal
        v-model:open="open"
        :initial-focus="loginButtonRef"
        prevent-dismiss
    >
        <template #headline>
            Das hat zu lange gedauert!
        </template>
        <template #default>
            <p>
                Du wurdest ausgeloggt, weil du zu lange inaktiv warst.<br>
                Um fortzufahren, melde dich bitte erneut an.
            </p>
        </template>
        <template #actions>
            <div class="inline-flex flex-col gap-s">
                <a
                    ref="loginButtonRef"
                    :href="buttonUrl"
                    aria-label="Erneut anmelden"
                    class="rounded inline-flex justify-center items-center font-medium px-l py-3 border border-solid
                        border-gray-900 transition-colors bg-green-400 hover:bg-green-500"
                >
                    Jetzt anmelden
                </a>
            </div>
        </template>
    </BaseModal>
</template>
